import React, { Component } from 'react';
import { Field } from 'redux-form';
import { injectIntl } from 'react-intl';


import RadioButtonField from './RadioButtonField';


class RadioListField extends Component {
  renderRadioButtons() {
    const { name, options, onChange } = this.props;
    return options.map(({ label, value }, index) => (
      <Field 
        name={name}
        label={label}
        key={index}
        radioValue={value}
        component={RadioButtonField}
        onChange={onChange}
      />
    ));
  }


  render() {
    let { className, label, intl, translation } = this.props;

    if (intl && translation) {
      const labelObj = translation.label;
      if(labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
    }

    return (
      <div className={className}>
        <label>{label}</label>
        {this.renderRadioButtons()}
      </div>
    );
  }
}


export default injectIntl(RadioListField);
